import React, { Component } from "react";
import { Form } from "react-form";
import TextFields from "../UI/TextFiled";
import SelectMenu from "../UI/Select";
import RadioGroup from "../UI/Radio";
import SwitchToggle from "../UI/SwitchToggle";
import ImageUpload from "../UI/ImageUpload";
import sha256 from "js-sha256";
import InputTabs from "../UI/InputTabs";
import Breadcrumb from "../UI/Breadcrumb";
import PageTitle from "../UI/PageTitle";
import { connect } from "react-redux";
import { editDriver, getDriver, getZones } from "../../store/actions";
import { breadcrumbs, COLORS, validate } from "../../utils/constants";

class EditDriver extends Component {
  state = {
    defaultValues: {},
    firstName: {
      eng: true,
      arb: false
    },
    lastName: {
      eng: true,
      arb: false
    }
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.getZones();
    this.props.getDriver(id);
  }

  onFormSubmitHandler = submittedValues => {
    if (submittedValues.password) {
      submittedValues.password = sha256(submittedValues.password);
    }
    this.props
      .editDriver(submittedValues, submittedValues.id)
      .then(res => this.props.history.push("/drivers"));
  };

  onFormChangeHandler = (formState, formApi) => {
    if (formState.touched && formState.touched.firstName_arb) {
      formApi.setTouched("firstName", true);
    }

    if (formState.touched && formState.touched.firstName) {
      formApi.setTouched("firstName_arb", true);
    }

    if (formState.touched && formState.touched.lastName_arb) {
      formApi.setTouched("lastName", true);
    }

    if (formState.touched && formState.touched.lastName) {
      formApi.setTouched("lastName_arb", true);
    }
  };

  render() {
    const { driver } = this.props;
    if (!driver) return null;

    return (
      <React.Fragment>
        <PageTitle title="Edit driver" />
        <div className="container">
          <Breadcrumb from={breadcrumbs.driver} current="Edit Drivers" />
        </div>

        <div className="container box inner-padding mb-15">
          <Form
            onSubmit={this.onFormSubmitHandler}
            onChange={this.onFormChangeHandler}
          >
            {formApi => (
              <form onSubmit={formApi.submitForm}>
                <div className="box-body">
                  <div className="row justify-between">
                    <div className="col-xs-6 pr-70">
                      <TextFields
                        formApi={formApi}
                        disabled
                        defaultValue={driver.id}
                        type="text"
                        label="Driver ID"
                        field="id"
                      />

                      <TextFields
                        formApi={formApi}
                        defaultValue={driver.driverIqamaSaudiId}
                        validations={[...validate.$tenNumbers]}
                        type="text"
                        label="Driver Iqama/Saudi ID"
                        field="driver_iqama_saudi_id"
                      />

                      <ImageUpload
                        validations={[...validate.image]}
                        defaultImage={driver.image}
                        label="Driver Image"
                      />

                      <InputTabs
                        validations={[...validate.$text]}
                        formApi={formApi}
                        field="firstName"
                        label="Driver First Name"
                        value="first_name"
                        defaultValue={driver.firstName}
                      />

                      <InputTabs
                        validations={[...validate.$text]}
                        formApi={formApi}
                        field="lastName"
                        label="Driver Last Name"
                        value="last_name"
                        defaultValue={driver.lastName}
                      />

                      <TextFields
                        formApi={formApi}
                        defaultValue={driver.mobileNumber}
                        validations={[...validate.$mobile]}
                        type="text"
                        label="Driver Mobile Number"
                        field="mobile_number"
                      />

                      <TextFields
                        formApi={formApi}
                        defaultValue={driver.email}
                        validations={[...validate.email]}
                        type="text"
                        label="Driver Email"
                        field="email"
                      />

                      <TextFields
                        formApi={formApi}
                        validations={[...validate.upToSixNumbersAndLetters]}
                        defaultValue={""}
                        type="text"
                        label="Driver Password"
                        field="password"
                      />

                      {this.props.zones ? (
                        <SelectMenu
                          field="zone"
                          formApi={formApi}
                          label="Agreed Zone"
                          defaultValue={driver.zone}
                          menu={this.props.zones}
                        />
                      ) : null}
                    </div>
                    <div className="col-xs-6 pl-70">
                      <TextFields
                        formApi={formApi}
                        defaultValue={driver.agreedDeposit}
                        validations={[...validate.$money]}
                        type="text"
                        label="Agreed Deposit"
                        field="agreed_deposit"
                      />

                      <div className="row">
                        <div className="col-xs-12 mt-20">
                          <p className="color-grey50 font-sm w-700">
                            Transport Description
                          </p>
                        </div>
                        <div className="col-xs-3">
                          <TextFields
                            formApi={formApi}
                            defaultValue={driver.transportYear}
                            validations={[...validate.$year]}
                            type="text"
                            label="Year"
                            field="transport_year"
                          />
                        </div>
                        <div className="col-xs-9">
                          <TextFields
                            formApi={formApi}
                            defaultValue={driver.transportModel}
                            validations={[...validate.$numbersAndLetters]}
                            type="text"
                            label="Model"
                            field="transport_model"
                          />
                        </div>
                      </div>
                      <TextFields
                        formApi={formApi}
                        defaultValue={driver.licensePlate}
                        validations={[...validate.$numbersAndLetters]}
                        type="text"
                        label="License Plate"
                        field="license_plate"
                      />

                      <SelectMenu
                        formApi={formApi}
                        defaultValue={driver.transportColor}
                        field="transport_color"
                        label="Color"
                        menu={COLORS}
                      />

                      <div className="mt-25">
                        <p className="color-grey50 font-sm w-700 pb-10">
                          Transport Type
                        </p>
                        <RadioGroup
                          defaultValue={driver.transportType}
                          labelFirst="Cooled"
                          valueFirst="cooled"
                          labelSecond="Normal"
                          valueSecond="normal"
                          field="transport_type"
                        />
                      </div>
                      <div className="mt-25 mb-15">
                        <p className="color-grey50 font-sm w-700 pb-10">
                          Full Time or Part Time
                        </p>
                        <RadioGroup
                          defaultValue={
                            driver.workType.includes("Full-time")
                              ? "Full-time"
                              : "Part-time"
                          }
                          labelFirst="Full"
                          valueFirst="Full-time"
                          labelSecond="Part"
                          valueSecond="Part-time"
                          field="work_type"
                        />
                      </div>
                      {formApi.values.work_type
                        ? formApi.values.work_type === "Full-time" && (
                            <TextFields
                              formApi={formApi}
                              defaultValue={driver.agreedFixedSalary}
                              validations={[...validate.$money]}
                              type="text"
                              label="Agreed Fixed Salary"
                              field="agreed_fixed_salary"
                            />
                          )
                        : driver.workType.includes("Full-time") && (
                            <TextFields
                              formApi={formApi}
                              defaultValue={driver.agreedFixedSalary}
                              validations={[...validate.$money]}
                              type="text"
                              label="Agreed Fixed Salary"
                              field="agreed_fixed_salary"
                            />
                          )}
                      <div className="mt-25">
                        <p className="color-grey50 font-sm w-700">
                          Driver Status
                        </p>
                        <div className="flex-center-y mt-20">
                          <span className="color-grey50 w-600 mr-15">
                            Inactive
                          </span>
                          <SwitchToggle
                            toggled={driver.status === "Active" ? true : false}
                            field="is_active"
                          />
                          <span className="color-primary w-600 ml-25">
                            Active
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="box-meta">
                  <div className="text-right">
                    <button
                      type="button"
                      onClick={() => this.props.history.push("/drivers")}
                      className="no-style w-600 pointer mx-20"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="btn filled primary min-120"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Form>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    editDriver: (data, id) => dispatch(editDriver(data, id)),
    getDriver: id => dispatch(getDriver(id)),
    getZones: () => dispatch(getZones())
  };
};

const mapStateToProps = state => {
  return {
    driver: state.driver.selected,
    zones: state.customer.zones
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditDriver);



// WEBPACK FOOTER //
// ./src/components/Driver/EditDriver.js